import { NavLink, Outlet } from "react-router-dom";
import { LogOut } from "lucide-react";
import { APP_NAME } from "../config/app";
import { useAuth } from "../app/AuthProvider";
import { useI18n } from "../i18n/I18nProvider";
import { getNavigationItems } from "../routes/navigation";
import { IconButton } from "../components/IconButton";

export function AppShell() {
  const { user, logout } = useAuth();
  const { t } = useI18n();
  const items = getNavigationItems(user);

  return (
    <div className="app-shell">
      <aside className="sidebar" aria-label="Primary">
        <div className="sidebar__brand">{APP_NAME}</div>
        <nav className="sidebar__nav">
          {items.map((item) => (
            <NavLink key={item.path} to={item.path} className={({ isActive }) => (isActive ? "nav-link nav-link--active" : "nav-link")}>
              {item.icon}
              <span>{t(item.labelKey)}</span>
            </NavLink>
          ))}
        </nav>
        <IconButton label={t("auth.logout")} variant="ghost" onClick={() => void logout()}>
          <LogOut size={19} aria-hidden="true" />
        </IconButton>
      </aside>
      <main className="main-content">
        <Outlet />
      </main>
      <nav className="bottom-nav" aria-label="Primary">
        {items.map((item) => (
          <NavLink key={item.path} to={item.path} className={({ isActive }) => (isActive ? "bottom-nav__item bottom-nav__item--active" : "bottom-nav__item")}>
            {item.icon}
            <span>{t(item.labelKey)}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
